import { useState, useEffect } from 'react';
import { Grid, Box, Tabs, Tab } from '@mui/material';
import PropTypes from 'prop-types';
import { io } from 'socket.io-client';

// SERVICES
import { getIdleActivas, getIdleHistorial } from '../../services/idle/getDatosIdle';
import { getCatalogoIncidencias } from '../../services/catalogo_incidencias/getDatosIncidencias';

// COMPONENTES
import Historial from './historial/Historial';
import Activos from './activos/Activos';

// =========================================
// COMPONENTE PERSONALIZADO
// =========================================

const CustomTabPanel = (props) => {

    const { children, value, index, ...other } = props;
    
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );

}

// =========================================
// PROP TYPES
// =========================================

CustomTabPanel.propTypes = {

    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,

};

// =========================================
// PROPS
// =========================================

const a11yProps = (index) => {

    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };

}

// ==========================================================

const MainIdleEvents = () => {

    // =========================================
    // FUNCION PARA CONTROLAR TABS
    // =========================================

    const [idleEventsActivos, setIdleEventsActivos] = useState([]);
    const [idleEventsHistorial, setIdleEventsHistorial] = useState([]);
    const [catalogoIncidencias, setCatalogoIncidencias] = useState([]);

    const getData = async () => {

        const [idleEventsActivosResponse, catalogoIncidenciasResponse, idleEventsHistorialResponse] = await Promise.all([
            getIdleActivas(),
            getCatalogoIncidencias(),
            getIdleHistorial()
        ]);

        setIdleEventsActivos(idleEventsActivosResponse);
        setCatalogoIncidencias(catalogoIncidenciasResponse);
        setIdleEventsHistorial(idleEventsHistorialResponse);

    };

    useEffect(() => {
        
        getData();

        const socket = io('https://apiuniddet.ebtapps.com');

        socket.on('connect', () => {
            console.log('Socket conectado');
        });

        socket.on('new_idle', async () => {
            const data = await getIdleActivas();
            setIdleEventsActivos(data);
        });

        socket.on('connect_error', (err) => {
            console.error('Error de conexión socket:', err.message);
        });

        return () => {
            socket.disconnect();
        };

    }, []);


    // =========================================
    // FUNCION PARA CONTROLAR TABS
    // =========================================

    const [tabValue, setTabValue] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    return (

        <Grid container>

            <Grid size={6} marginBottom={2}>

                <Tabs value={tabValue} onChange={handleTabChange} aria-label="basic tabs example">
                    <Tab label="Activos"  {...a11yProps(0)}/>
                    <Tab label="Historial"  {...a11yProps(1)}/>
                </Tabs>

            </Grid>

            <Grid size={12}>

                <CustomTabPanel value={tabValue} index={0}>

                    <Activos 
                        eventos={idleEventsActivos}
                        indicencias={catalogoIncidencias}
                        refresh={getData}
                    />

                </CustomTabPanel>

                <CustomTabPanel value={tabValue} index={1}>

                    <Historial
                        eventos={idleEventsHistorial}
                    />

                </CustomTabPanel>

            </Grid>

        </Grid>

    )

}

export default MainIdleEvents